import React from "react";

const ContactInfo = () => {
  return (
    <div className="content" data-aos="fade-up" data-aos-delay="200">
      <h1 className="main-contact-heading fs-xl-heading">
        Get in touch with us
      </h1>
      <p className="descriptive-sub-heading mb-4">
        Unleash the future of manufacturing with AI-Vision and Robotics
      </p>
      <div className="lead">
        Step into the future with us as we revolutionize the manufacturing
        landscape. Whether you're a trailblazing professional eager to make
        your mark, or a visionary customer ready to elevate your business with
        state-of-the-art tech, together we'll shape a new era. It's time to
        push boundaries, ignite innovation, and redefine manufacturing.
      </div>

      <div className="contact-info mt-5">
        <div className="info-item d-flex mb-3">
          <span>info@terafac.com</span>
        </div>

        <div className="info-item d-flex mb-3">
          <span>+91 8264445150</span>
        </div>

        <div className="info-item d-flex mb-4">
          <span>Chandigarh, India</span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
